




































import { defineComponent } from '@vue/composition-api';

import AtomButton from '@/components/atoms/AtomButton.vue';
import HintText from '@/components/atoms/HintText.vue';

import AdvisorSearchFormAutoComplete from '@/modules/advisor-search/organisms/AdvisorSearchForm/AdvisorSearchFormAutoComplete.vue';
import { useAdvisorSearchForm } from '@/modules/advisor-search/organisms/AdvisorSearchForm/AdvisorSearchForm';

export default defineComponent({
  name: 'AdvisorSearchForm',
  components: {
    AtomButton,
    HintText,

    AdvisorSearchFormAutoComplete,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { state, onInput, search } = useAdvisorSearchForm(props, context);
    return {
      state,
      onInput,
      onClickButton(e: PointerEvent) {
        if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
          e.preventDefault();
          search();
        }
      },
    };
  },
});
